import {getFieldRegistration, ssoLink, updateFieldNew} from "@common/api";
import {accessToken, timeStamp} from "@common/utils";
import {mandatory_no_require, type_checkbox, type_radio, type_text} from "@common/constact";
import {uuid} from "@common/utils";
import {becomeArray} from "@common/utils";

var initState = {
    projectId: "",
    createOrEdit: "",
    dialog: {
        title: "字段管理",
        isShowUpDateDialog: false
    },
    isEditModel: false,//是不是编辑模式
    fieldsBody: [],//界面的字段
    bodyMap: {},
    cascades: [],//字段的下拉
    cache_current_filed: {}, //正在编辑的field
}
export default {
    namespaced: true,
    state: initState,
    getters: {getFieldRegistration},
    mutations: {
        set_cache_current_filed(state, cache_current_filed) {
            cache_current_filed.display = becomeArray(cache_current_filed.display)
            cache_current_filed.parameter = becomeArray(cache_current_filed.parameter).join('\n')
            state.cache_current_filed = cache_current_filed
        },
        set_isEditModel(state, isEditModel) {
            state.isEditModel = isEditModel
        },
        set_propjectId(state, projectId) {
            state.projectId = projectId
        },
        set_projectName(state, projectName) {
            state.projectName = projectName
        },
        set_body_bodyMap(state, body) {
            state.fieldsBody = body
            body.map(item => {
                state.bodyMap[item.id] = item
            })
        },
        set_cascades(state, cascades) {
            state.cascades = cascades
        },
        set_dialog_createOrEdit_show(state) {
            state.dialog.isShowUpDateDialog = true
        },
        set_close_isShowUpDateDialog(state) {
            state.dialog.isShowUpDateDialog = false
        }
    },
    actions: {
        action_validate_return_update_params({state}, params) {
            var params = {
                accessToken: accessToken(),
                timeStamp: timeStamp(),
                projectId: state.projectId,
                src: '0', // 0参展商1采购商

            }

        },
        actions_uplodeFields({state, commit}, params) {
            var params = {
                accessToken: accessToken(),
                timeStamp: timeStamp(),
                projectId: state.projectId,
                src: '0', // 0参展商1采购商
                id: params.fieldId,
                nameZh: params.nameZh,
                nameEn: params.nameEn,
                parameter: params.parameter.trim(),
                display: params.display.join(','),
                defaults: params.defaults,
                length: params.length,
                mandatory: params.mandatory
            }
            //处理是 type_checkbox  type_radio的特殊情况
            if (state.cache_current_filed.type === type_checkbox) {
                params.defaults = JSON.stringify([])
            }
            if (state.cache_current_filed.type === type_radio) {
                params.defaults = ""
            }

            return updateFieldNew(params).then(res => {
                if (res.code == '0') {
                    return res
                } else {
                    throw res
                }
            })
        },
        fetch_get_body({state, commit}) {
            var navArr = []
            // 0参展商1采购商
            let params = {
                accessToken: accessToken(),
                timeStamp: timeStamp(),
                projectId: state.projectId,
                src: '0'
            }
            getFieldRegistration(params).then(res => {
                if (res.code != 0) {
                    return res
                }
                //成功之后
                commit('set_body_bodyMap', res.data.defaults)
                commit('set_cascades', res.data.cascades)
            })
        },
        actions_add_type({state, commit}, type) {
            commit('set_createOrEdit_show')
            if (type === type_text) {
                var one = {
                    id: uuid(),
                    nameZh: "",
                    type: type,
                    nameEn: "",
                    display: "",//zh,en
                    mandatory: mandatory_no_require, //1 必填 不填
                    defaults: "",
                    parameter: "",
                    length: 250,
                }
            }
        }

    }
}


// WEBPACK FOOTER //
// ./src/admin/components/organizer/supplierFieldSetting/supplierFieldSettingStore.js